import CryptoJS from "crypto-js";
var IsEncryption;
var AuthFlg = false;
const tokenKey = '0123456789ABCDEF0123456789ABCDEF';

const privateFunc = {
    //nullチェック
    isNull (val) {
        return val === null;
    },
    //文字列暗号化
    cryEncode: function (txt) {
        if (!this.isNull(txt)) {
            var rtn = CryptoJS.AES.encrypt(String(txt), tokenKey).toString();
            return rtn;
        }

    },

    //オブジェクト⇒文字列⇒暗号化
    objEncode: function (obj) {
        for (let [key, val] of Object.entries(obj)) {
            if (this.isNull(obj[key])) { continue }
            if (Array.isArray(obj[key])) {
                obj[key] = this.arrEncode(val);
            }
            else if (typeof obj[key] == 'object') {
                obj[key] = this.objEncode(obj[key])
            }
            else {
                obj[key] = this.cryEncode(val);
            }
        }
        return obj;
    },

    //配列⇒文字列⇒暗号化
    arrEncode: function (arr) {
        for (var i = 0; i < arr.length; i++) {
            if (this.isNull(arr[i])) { continue }
            if (Array.isArray(arr[i])) {
                arr[i] = this.arrEncode(arr[i]);
            }
            else if (typeof arr[i] == 'object') {
                arr[i] = this.objEncode(arr[i])
            }
            else {
                arr[i] = this.cryEncode(arr[i]);
            }
        }
        return arr;
    },

    //文字列復号化
    cryDecode: function (txt) {
        if (!this.isNull(txt)) {
            return CryptoJS.AES.decrypt(txt, tokenKey).toString(CryptoJS.enc.Utf8);
        }
    },

    //オブジェクト⇒文字列⇒復号化
    objDecode: function (obj) {

        for (let [key, val] of Object.entries(obj)) {
            if (this.isNull(obj[key])) { continue }
            if (Array.isArray(obj[key])) {
                obj[key] = this.arrDecode(val);
            } else if (typeof obj[key] == 'object') {
                obj[key] = this.objDecode(obj[key])
            }
            else {
                obj[key] = this.cryDecode(val);
            }
        }
        return obj;
    },

    //配列⇒文字列⇒復号化
    arrDecode: function (arr) {
        for (var i = 0; i < arr.length; i++) {
            if (this.isNull(arr[i])) { continue }
            if (typeof arr[i] == 'object') {
                arr[i] = this.objDecode(arr[i])
            } else if (Array.isArray(arr[i])) {
                arr[i] = this.arrDecode(arr[i]);
            }
            else {
                arr[i] = this.cryDecode(arr[i]);
            }
        }
        return arr;
    }
}

export const commonFunctions = {
    install: ((Vue, options) => {
        Vue.prototype.$functions = {
            setIsEncryption(isEncryption) {
                if (isEncryption == undefined) isEncryption = false;
                IsEncryption = isEncryption;
            },
            //セッションストレージ格納
            setSStorage: function (strageName, data) {
                if (Array.isArray(data)) {
                    data = privateFunc.arrEncode(data);
                }
                else if (typeof data == 'object') {
                    data = privateFunc.objEncode(data);
                }
                else {
                    data = privateFunc.cryEncode(data);
                }
                sessionStorage.setItem(strageName, JSON.stringify(data));
            },

            //セッションストレージ取得
            getSStorage: function (strageName) {
                // strageName = this.checkStrage(strageName);
                var data = JSON.parse(sessionStorage.getItem(strageName))

                if (Array.isArray(data)) {
                    data = privateFunc.arrDecode(data);
                }
                else if (typeof data == 'object') {
                    data = privateFunc.objDecode(data);
                }
                else {
                    data = privateFunc.cryDecode(data);
                }
                return data;
            },



            setAuthFlg() {
                AuthFlg = true;
            },
            isAuth() {
                return sessionStorage.getItem('userInfo') != null;
            },
            swAlert(vm, icon, title, msg){
                return vm.$swal({
                    title: title,
                    icon: icon,
                    text: msg,
                    showCancelButton: true,
                    reverseButtons : true
                })
            },
            swNgAlert(vm, icon, title, msg){
                return vm.$swal({
                    title: title,
                    icon: icon,
                    text: msg
                })
            },
            reload(vm){
                vm.$router.go({path: vm.$router.currentRoute.path, force: true})
            },
        }
    })
}
export { commonFunctions as default }
